<template>
  <div
    class="total-profit"
    :class="{
      'blance-bgc': $store.state.sideMenuId !== 'dashboard',
      'dashboard-total-profit': $store.state.sideMenuId === 'dashboard'
    }">
    <div
      v-if="isBtoC && $store.state.sideMenuId === 'dashboard'"
      class="dashboard-total-profit__icon">
      <!-- eslint-disable max-len -->
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect
          x="1"
          y="1"
          width="54"
          height="54"
          rx="7"
          fill="white"
          stroke="#FF2289"
          stroke-width="2"/>
        <path
          d="M26.7013 43V36.4324H18.1009V33.8735H26.7013V29.7794H18.1009V27.2206H25.4629L17 14H20.079L28.0086 26.4018L35.921 14H39L30.5371 27.2206H37.8991V29.7794H29.2987V33.8735H37.8991V36.4324H29.2987V43H26.7185H26.7013Z"
          fill="#FF2289"/>
      </svg>
      <!-- eslint-enable max-len -->
    </div>
    <div
      class="total-profit__title"
      :class="{ 'dashboard-total-profit__title': $store.state.sideMenuId === 'dashboard' }">
      収益合計
    </div>
    <router-link
      v-if="isBtoC && $store.state.sideMenuId === 'dashboard'"
      v-show="!hide"
      :to="{ name : 'report-finalized' }"
      class="c-text-link"
      :class="{ 'dashboard-c-text-link': $store.state.sideMenuId === 'dashboard' }">
      確定レポートを見る
    </router-link>
    <div
      class="total-profit__price"
      :class="{
        'blance-padding': $store.state.sideMenuId !== 'dashboard',
        'dashboard-total-profit__price': $store.state.sideMenuId === 'dashboard'
      }">
      ¥{{ paymentBalance | roundNumber }}
    </div>
    <div
      v-show="true"
      class="c-btn-wrap c-btn-wrap--total-price"
      :class="{ 'dashboard-c-btn-wrap': $store.state.sideMenuId === 'dashboard' }">
      <router-link
        v-if="$store.state.sideMenuId === 'dashboard'"
        :to="{ name : 'balance' }"
        class="c-btn"
        :class="{ 'dashboard-c-btn': $store.state.sideMenuId === 'dashboard' }">
        {{ buttonTitle }}
        <span class="c-btn__icon-arrow"></span>
      </router-link>
      <div
        v-else-if="subscriptionCarrierFeePending"
        v-show="!hidenPayment"
        class="c-btn"
        @click.prevent="showDialog=true">
        {{ buttonTitle }}
        <span class="c-btn__icon-arrow"></span>
      </div>
      <router-link
        v-else
        v-show="!hidenPayment"
        :to="{ name : 'withdrawal' }"
        class="c-btn">
        {{ buttonTitle }}
        <span class="c-btn__icon-arrow"></span>
      </router-link>
    </div>
    <router-link
      v-if="isBtoB || (isBtoC && $store.state.sideMenuId !== 'dashboard')"
      v-show="!hide"
      :to="{ name : 'report-finalized' }"
      class="c-text-link">
      確定レポートを見る
    </router-link>
    <confirm-dialog
      name="subscriptionCarrierFeePending"
      :is-shown="showDialog"
      :default-button-title="'決済情報を更新する'"
      :cancel-button-title="false"
      title="支払い申請を行うことができません"
      @closed="showDialog = false"
      @default-clicked="onSubscriptionCarrierFeePendingClicked">
      <template #body>
        支払い申請を行うためには<br>決済情報を更新する必要があります。
      </template>
    </confirm-dialog>
  </div>
</template>

<script>
import ConfirmDialog from '../../../../components/ConfirmDialog'

export default {
  name: 'BalanceReport',
  components: {
    ConfirmDialog,
  },
  filters: {
    roundNumber(value) {
      return value
        ? new Intl.NumberFormat('ja-JP').format(Math.round(value * 100) / 100)
        : 0
    },
  },
  props: {
    hide: {
      type: Boolean,
      default: false,
    },
    hidenPayment: {
      type: Boolean,
      default: false,
    },
    buttonTitle: {
      type: String,
      default: '支払い申請',
    },
    subscriptionCarrierFeePending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paymentBalance: '',
      showDialog: false,
    }
  },
  mounted() {
    this.fetchBalance()
  },
  methods: {
    async fetchBalance() {
      const { data } = await window.axios.get('/api/client/payments/balances')
      this.paymentBalance = data
    },
    onSubscriptionCarrierFeePendingClicked() {
      this.$router.push({ name: 'settlement-method-change' })
    },
  },
}
</script>

<style scoped>
.blance-bgc {
  background-color: #f3f3f1;
}
.blance-padding {
  padding: 15px 0 10px;
}
</style>
